<template>
  <div id="couponplatz"
       :class="config.epost.enabled ? config.cssClassPrefix + 'epost-enabled' : ''">
    <transition name="fade">
      <div v-if="!cards.length"
           :class="config.cssClassPrefix + 'loading'">
        <img src="https://couponplatz.de/img/couponplatz-logo.svg"
             width="250"
             alt="Logo: couponplatz.de" />
      </div>
    </transition>
    <transition name="fade">
      <div v-if="cards.length">
        <div :class="config.cssClassPrefix + 'toolbar'">
          <div :class="config.cssClassPrefix + 'total-coupon-count'">
            Du hast
            <span v-if="totalCount() > 1"
                  :class="config.cssClassPrefix + 'total-coupon-amount'">
              {{ totalCount() }}
            </span>
            <span v-if="totalCount() === 0">noch keine</span>
            <span v-if="totalCount() === 1">einen</span>
            Coupon<span v-if="totalCount() !== 1">s</span>
            gesammelt.
          </div>
          <div :class="[ config.cssClassPrefix + 'cart-savings', totalCount() < config.print.minNoOfCoupons ? config.cssClassPrefix + 'less-than-minimum' : '' ]">
            <span v-on:click="showCart = !showCart"
                  :class="config.cssClassPrefix + 'cart-arrow'"></span>
            Du sparst {{ totalSavingsValue() | formatDecimal }} €
            <transition name="slide-fade">
              <table :class="[ config.cssClassPrefix + 'cart' ]"
                     v-if="showCart">
                <tr v-if="totalCount() === 0">
                  <td colspan="5">Dein Warenkorb ist einsam. Und traurig. :-(<br/>
                    Bring ihm doch ein paar Couponfreunde zum Spielen vorbei!
                  </td>
                </tr>
                <tr v-for="cartItem in cart.items"
                    :class="config.cssClassPrefix + 'cart-item'">
                  <td>{{ cartItem.count }}</td>
                  <td>x</td>
                  <td>{{ cartItem.name }}</td>
                  <td :class="config.cssClassPrefix + 'tar'">
                    {{ (cartItem.count * cartItem.facevalue / 100) | formatDecimal }} €
                  </td>
                  <td>
                    <button :class="config.cssClassPrefix + 'cart-item-remove'"
                            v-on:click="remove(cartItem)">x</button>
                  </td>
                </tr>
                <tr v-if="totalCount() > 0">
                  <td colspan="5">
                    <hr />
                  </td>
                </tr>
                <tr :class="config.cssClassPrefix + 'cart-item'"
                    v-if="totalCount() > 0">
                  <td>{{ totalCount() }}</td>
                  <td>x</td>
                  <td>sparen =</td>
                  <td :class="config.cssClassPrefix + 'tar'">{{ totalSavingsValue() | formatDecimal }} €</td>
                  <td></td>
                </tr>
              </table>
            </transition>
          </div>
          <transition name="fade">
            <form :action="config.print.actionUrl"
                  method="post"
                  enctype="application/x-www-form-urlencoded"
                  accept-charset="UTF-8"
                  :target="config.print.openInNewTab ? '_blank' : ''"
                  v-if="config.print.enabled || config.epost.enabled"
                  v-on:submit="printCoupons"
                  :class="config.cssClassPrefix + 'cart-form'">
              <input type="hidden"
                     v-model="cartBase64"
                     :name="config.print.cartInputName"
                     id="config.print.cartInputName" />
              <input type="hidden"
                     :value="config.print.pdfFileName"
                     name="filename"
                     id="filename" />
              <input type="hidden"
                     :value="config.print.forceDownload"
                     name="forcedownload"
                     id="forcedownload" />
              <button type="submit"
                      :class="config.cssClassPrefix + 'cart-form-print'"
                      title="Coupons einfach ausdrucken und lossparen!"
                      v-if="config.print.enabled">
                <img src="https://www.couponplatz.de/img/ausdrucken.svg" alt="Coupons ausdrucken" />
              </button>
              <button type="button"
                      :class="config.cssClassPrefix + 'cart-form-epost'"
                      title="Coupons zuschicken lassen"
                      v-on:click.prevent="epostSend"
                      v-if="config.epost.enabled"
                      v-bind:enabled="config.epost.minNoOfCoupons <= totalCount()">
                <img src="https://www.couponplatz.de/img/epost.svg" alt="Coupons zuschicken lassen" />
              </button>
            </form>
          </transition>
        </div>

        <transition name="fade">
          <epost-form v-bind:cart-base64="cart.getCartBase64()" v-bind:show-epost-form="showEpostForm" v-if="config.epost.enabled"></epost-form>
        </transition>

        <ul :class="config.cssClassPrefix + 'cards'">
          <li v-for="card in cards"
              v-bind:class="[ activeCard.couponcode === card.couponcode ? 'couponplatz-card-is-active' : '', config.cssClassPrefix + 'card-container' ]">
            <div class="couponplatz-card"
                 v-on:click="toggleActive(card)">
              <img :src="card.brand.url"
                   :alt="card.brand.title"
                   :class="config.cssClassPrefix + 'brand-img'"/>
              <span :class="config.cssClassPrefix + 'facevalue'">
                <small>Coupon</small>
                {{ card.facevalue / 100 | formatDecimal }} €
                <span :class="config.cssClassPrefix + 'save-text'">Sparen</span>
              </span>
              <span :class="config.cssClassPrefix + 'coupon-expiry'">
                Gültig bis {{ card.expires | formatDate }}
              </span>
              <img :class="config.cssClassPrefix + 'product-img'"
                   :src="card.media.productshot_small"
                   :alt="card.title"/>
              <div :class="config.cssClassPrefix + 'card-title'">{{ card.title }}</div>
              <div :class="config.cssClassPrefix + 'coupon-amount-control'">
                <button :class="config.cssClassPrefix + 'minus'"
                        v-on:click.stop="decreaseCouponCount(card)"
                        :disabled="!cardCount(card)">-</button>
                <span :class="config.cssClassPrefix + 'card-count'"
                      v-if="cardCount(card)">{{ cardCount(card) }}</span>
                <span v-on:click.stop="increaseCouponCount(card)"
                      v-if="!cardCount(card)"
                      v-bind:class="config.cssClassPrefix + 'card-select'">Auswählen</span>
                <button :class="config.cssClassPrefix + 'plus'"
                        v-on:click.stop="increaseCouponCount(card)"
                        :disabled="totalCount() >= config.maxCouponCount"
                        :title="totalCount() >= config.maxCouponCount ? 'Maximale Coupon-Anzahl erreicht' : 'Klicke hier, um einen ' + card.title.split(' ').join('-') + '-Coupon hinzuzufügen.'">+</button>
              </div>
            </div>
            <div :class="config.cssClassPrefix + 'card-preview'">
              <img :src="card.media.brand_small"
                   :alt="card.brand.title"
                   :class="config.cssClassPrefix + 'brand-img'"/>
              <span :class="config.cssClassPrefix + 'coupon-expiry'">
                Gültig bis {{ card.expires | formatDate }}
              </span>
              <span>{{ card.condition }}</span>
              <span>{{ card.disclaimer }}</span>
              <img :class="config.cssClassPrefix + 'product-img'"
                   :src="card.media.productshot_small"
                   :alt="card.title"/>
              <div :class="config.cssClassPrefix + 'card-title'">{{ card.title }}</div>
              <span v-on:click="activeCard={}" :class="config.cssClassPrefix + 'card-preview-close'"></span>
            </div>
          </li>
          <li :class="config.cssClassPrefix + 'cards-overlay'" v-if="totalCount() >= config.maxCouponCount">
            <div :class="config.cssClassPrefix + 'cards-overlay-content'">
              <img src="//www.codestylers.de/couponplatz/couponplatz-logo.svg" width="250"
                   alt="Logo: couponplatz.de" style="background-color: #fff;"/>
              <h2>Du hast die maximale Anzahl von {{ config.maxCouponCount }} Coupons erreicht.</h2>
            </div>
          </li>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script>
	"use strict";
	import Vue from 'vue';
	const config = require('./assets/json/couponplatz.config.json');
	const util = require('./assets/js/util/util');
	const bindMethods = util.bindMethods;
	const exportMethods = util.exportMethods;
	const guid = util.guid;
	const isGuid = util.isGuid;
	const viewHelper = require('./assets/js/ViewHelper');
	const CardList = require('./assets/js/domain/CardList');
	const Cart = require('./assets/js/domain/Cart.js');
	const store = require("store");
  var EQ = require('../node_modules/css-element-queries/src/ElementQueries');
	require('./assets/main.scss');

	const cart = new Cart;
	const cardList = new CardList;

	bindMethods(cart);
	bindMethods(cardList);
	const cartMethods = exportMethods(cart);
	const cardListMethods = exportMethods(cardList);

	//  (function() {
	//		let unique_id = "";
	//    let stored_unique_id = store.get("unique_id");
	//    if(stored_unique_id && isGuid(stored_unique_id)) {
	//		  unique_id = stored_unique_id;
	//    } else {
	//      unique_id = guid();
	//      store.set("unique_id", unique_id);
	//    }
	//  }());

  var epostForm = {
	  template: require('./assets/template/_epost.vtpl'),
	  props: {
	  	cartBase64: String,
      showEpostForm: Boolean,
    },
    data () {
		  return {
        config: config,
        address: {
        	salutation: "Frau",
        	firstname: "",
          lastname: "",
          street: "",
          streetnumber: "",
          zipcode: "",
          city: "",
          additionalline: "",
          email: "",
          newsletter_subscribe: false,
          tos: false,
        },
        addressBase64: function() {
        	return btoa(JSON.stringify(this.address));
        },
      };
	  },
    methods: {
	  	send: function() {
	  		console.log(this.address);
      },
      close: function() {
	  		this.$root.showEpostForm = false;
      }
    }
  };

	export default {
		name: 'couponplatz',
		data () {
			return {
				isReady: false,
				cards: cardList.getCards(),
				acceptors: cardList.getAcceptors(),
				cart: cart,
				activeCard: {},
				showCart: false,
        showEpostForm: false,
				cartBase64: cart.getCartBase64(),
				config: config,
			};
		},
		methods: Object.assign({
			decreaseCouponCount: function (card) {
				"use strict";
				let cartItem = this.cart.items.find(item => {
					return item.couponcode === card.couponcode;
				});
				if (!cartItem) throw ("item not in cart");
				cartItem.count--;
				if (!cartItem.count) {
					let index = this.cart.items.indexOf(cartItem);
					this.cart.items.splice(index, 1);
				}
				this.updateCartStorage();
			},
			increaseCouponCount: function (card) {
				"use strict";
				if (this.config.maxCouponCount <= cart.totalCount()) return;
				cart.add(card);
			},
			printCoupons: function () {
				"use strict";
				this.cartBase64 = cart.getCartBase64();
				this.cart.clear();
				return false;
			},
      epostSend: function () {
        "use strict";
        this.cartBase64 = cart.getCartBase64();
        this.showCart = false;
        this.showEpostForm = true;
        //this.cart.clear();
        return false;
      },
			toggleActive: function (card) {
				"use strict";
				this.activeCard = this.activeCard.couponcode === card.couponcode ? {} : card;
			},
		}, cartMethods, cardListMethods),
		filters: Object.assign({}, viewHelper),
	  components: {
		  'epost-form': epostForm,
	  },
	}
</script>


// WEBPACK FOOTER //
// couponplatz.vue?d9baabba